import { createFileRoute } from "@tanstack/react-router";

import SetupWizard from "@/components/SetupWizard";

/**
 * `/setup` -- the break-glass bootstrap wizard.
 *
 * **Deliberately not behind `RequireAuth`.** It exists precisely for the state where nobody can
 * sign in yet: a fresh environment where Okta is unconfigured, so `/v1/auth/login` answers
 * `sso-not-configured` and there is no session to require. Gating it would make the one page
 * that fixes an unconfigured platform reachable only on a configured one.
 *
 * It is not ungated, though. The wizard authenticates against the break-glass credential
 * server-side, and the setup routes 404 -- never 403 -- once setup is complete or the record is
 * absent, expired or disabled, so a 404 leaks nothing about whether the page ever did anything.
 */
export const Route = createFileRoute("/setup")({
  component: SetupWizard,
});
